import { useState } from 'react'
import { SeeMore, RequestItem } from '@/components'
import { IRequestItem } from '../RequestItem'
import { BaseProps } from '@/components/types'

function RequestItemList ( props: RequestItemListProps ) {
    const {
        itemList, defaultShowItemCount = 10, marginTop = '8px', marginBottom = '8px',
        onClickDetail,
        ...rest
    } = props
    const [ showItemCount, setShowItemCount ] = useState( defaultShowItemCount )

    return (
        <>
            {
                itemList && itemList.map( (
                    data, idx
                ) => {
                    return (
                        <RequestItem
                            { ...rest }
                            key={ `${ data.propertyNo }${ idx }` }
                            data={ data }
                            onClickDetail={ onClickDetail }
                        />
                    )
                } ).slice( 0, showItemCount > itemList.length ? itemList.length : showItemCount )
            }
            {
                itemList.length !== 0 && <SeeMore
                    defaultShowCount={ defaultShowItemCount }
                    setShowCount={ setShowItemCount }
                    marginTop={ marginTop }
                    marginBottom={ marginBottom }
                    totalList={ itemList }
                />
            }
        </>
    )
}

export default RequestItemList

export interface RequestItemListProps extends BaseProps {
    itemList: IRequestItem[]
    defaultShowItemCount?: number
    marginTop?: string | number
    marginBottom?: string | number
    onClickDetail?: ( data: IRequestItem ) => void
}
